import heroImg from '../../../utils/images/hero-img.png';

import './homepage.css';

const HeroSection = () => {
  return (
    <section className="hero-section page-width px-3 row mb-5 pb-5">
        <div className="col-md-7 col-sm-12 my-3 my-md-4">
          <div className="hero-section_text js-scroll slide-left pt-sm-0 pt-md-5 mt-sm-0 mt-md-4">
            <p>#cosmosconference, 2024.</p>
            <h1 className='text-uppercase mb-0'>THE GATEKEEPERS OF INNOVATION</h1>
            <h4 className='text-uppercase custom-cosmos'>DESIGNING FOR NATION BUILDING</h4>
          </div>
        </div>

        <div className="col-md-5 col-sm-12 my-3 my-md-4">
          <div className="hero-section_img container js-scroll slide-right text-center">
            <div className="ball rounded-circle"></div>
            <img src={heroImg} alt="" width='100%' height='' className='img-fluid' />
          </div>
        </div>
      </section>
  )
}

export default HeroSection